import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CommonService } from '../../../common/services/common.service';
import { HeroTileService } from '../../../core/routing/services/asset-library/hero-tile.service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { DataService } from '../../../core/data/data-service';
import { HeroTile, HeroTileConfiguration, HeroTilePreview, HeroTilePreviewData } from '../hero-tile/hero-tile/interfaces/hero-tile.i';
import { RetailHq } from '../../users/interface/retail.i';
import { DomSanitizer } from '@angular/platform-browser';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { Utils } from '../../../common/utils/utils';

@Component({
  selector: 'iposcen-create-hero-tile',
  templateUrl: './create-hero-tile.component.html',
  styleUrls: ['./create-hero-tile.component.scss']
})
export class CreateHeroTileComponent implements OnInit, OnDestroy {
  @Input() pageType: string;
  @Output() readonly goBacktoHeroTileLists = new EventEmitter<object>();
  @Output("refreshHeroTiledata") refreshHeroTiledata = new EventEmitter<any>();
  @Output("ctatextvalue") ctatextvalue = new EventEmitter<object>();
  heroTileForm: FormGroup;
  isSubmitted = false;
  imageSizeError: boolean;
  imageTypeError: boolean;
  isImageAvailable = false;
  isFormValid: boolean;
  isImageFormat: boolean;
  imageFileType: string;
  imageFileName: string;
  imageFileSize: number;
  createHeroTileButton = AssetLibraryConstants.NEW_HERO_TILE_ASSET;
  publishNamePlaceholder = AssetLibraryConstants.PUBLISHED_NAME_PLACEHOLDER;
  internalNamePlaceholder = AssetLibraryConstants.INTERNAL_NAME_PLACEHOLDER;
  callToActionPlaceholder = AssetLibraryConstants.CALL_TO_ACTION_PLACEHOLDER;
  media = {} as any;
  listOfRetailerHq = [];
  heroTilePreviewData: HeroTilePreview;
  selectedHeroTileContent: HeroTile;
  selectedHeroTileId;
  isPublished: boolean;
  heroImageDoc: any;
  gamingBannerDoc: any;
  exeFileDoc: any;
  fallbackExe: any;
  imageUrl: any = '';
  isRemoveEnabled: boolean;
  selectedRetailerId;
  selectedRetailerName;
  heroTileFileName: string;
  heroTileSizeError;
  heroTileAvailable = false;
  heroTileFormat: boolean;
  heroTileTypeError: boolean;
  heroImageURL: any = '';
  gamingBannerFileName: string;
  gamingBannerSizeError;
  gamingBannerAvailable = false;
  gamingBannerFormat: boolean;
  gamingBannerTypeError: boolean;
  gamingBannerImageURL: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  fileTypeError: boolean;
  fileSizeError;
  isFileAvailable = false;
  isFileFormat: boolean;
  fileUrl: any = '';
  isRetailerAvailable = false;
  editCheck = false;
  srtPattern = GlobalConstants.SRT_URL;
  emailValidationMsg = GlobalConstants.EMAIL_VALIDATION_MSG;
  selectedRetailer: any;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  patterMatch: boolean;
  srtUrlText: string;
  srtUrlPlaceholder = GlobalConstants.HTTPS_PLACEHOLDER;
  retailSearch = GlobalConstants.SRT_RETAILERHQ_PLACEHOLDER;
  globConst = GlobalConstants;
  bgColor: string;
  gamingBgColor: string;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private heroTileService: HeroTileService,
    private sanitizer: DomSanitizer,
    private cmnSer: CommonService
    ) { }

  ngOnInit(): void {
    this.heroTilePreviewData = {
      image: {
        name: '',
        url: '',
        format: ''
      },
      button: { 
        value: ''
      }
    };
    this.patterMatch = true;
    this.dataService.getHeroTile()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((heroTileToEdit: any) => {
        if (heroTileToEdit) {
          this.editCheck = true;
          this.isFileFormat = true;
          this.heroTileFormat = true;
          this.gamingBannerFormat = true;
          this.isFileAvailable = true;
          this.gamingBannerAvailable = true;
          this.heroTileAvailable = true;
          this.isSubmitted = false;
          this.selectedHeroTileContent = heroTileToEdit;
          const uploadedFileData = typeof this.selectedHeroTileContent.configurations === 'string' ? JSON.parse(this.selectedHeroTileContent.configurations) : this.selectedHeroTileContent.configurations;
          this.heroTileFileName = uploadedFileData.heroImageFile;
          this.gamingBannerFileName = uploadedFileData.gamingImageFile;
          this.fileName = uploadedFileData.fallbackExeFile;
          this.heroTilePreviewData.image.url = this.selectedHeroTileContent.heroImageURL;
          this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.HERO_TILE, dataSet: this.heroTilePreviewData });
          this.selectedHeroTileId = this.selectedHeroTileContent.id;
          this.isPublished = !(this.selectedHeroTileContent.publishedName !== '');
          this.selectedRetailerId = this.selectedHeroTileContent.retailerId;
          this.selectedRetailerName = this.selectedHeroTileContent.retailerName;
          this.selectedRetailer = this.selectedRetailerName;
          this.isRetailerAvailable =  (this.selectedHeroTileContent.retailerId !== '');
        }
      });
    this.createHeroTileGroupForm();
    this.getRetailerDetails();
    this.srtUrlText = $localize`:@@create-hero-tile.srt-url:Intel® Shopper Recommendation Tool URL`;
    this.cmnSer.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if (data === true) {
        this.cmnSer.setSwitchstatus(true);
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  cancel() {
    this.isSubmitted = false;
    this.goBacktoHeroTileLists.emit({ cancel: true });
    this.dataService.setHeroTile(undefined);
  }

  createHeroTileGroupForm() {
    this.heroTileForm = this.formBuilder.group({
      publishedName: new FormControl((this.selectedHeroTileContent) ? this.selectedHeroTileContent.publishedName : '',
        [Validators.required, Validators.maxLength(50)]),
      internalName: new FormControl((this.selectedHeroTileContent) ? this.selectedHeroTileContent.internalName : ''),
      srtUrl: new FormControl((this.selectedHeroTileContent) ? this.selectedHeroTileContent.srtUrl : ''),
      callToAction: new FormControl((this.selectedHeroTileContent) ? this.selectedHeroTileContent.callToAction : ''),
      retailerHq: new FormControl((this.selectedHeroTileContent) ? this.selectedHeroTileContent.retailerName : '')
    });
    this.ctatextvalue.emit(this.heroTileForm.controls.callToAction.value || GlobalConstants.HERO_TILE_CTA_BUTTON_DEFAULT_TEXT);
    const uploadedFileData = this.selectedHeroTileContent?.configurations ? typeof this.selectedHeroTileContent.configurations === 'string' ? JSON.parse(this.selectedHeroTileContent.configurations) : this.selectedHeroTileContent.configurations : {};
    this.bgColor = uploadedFileData?.bgColor ? uploadedFileData?.bgColor : '#000000';
    this.gamingBgColor = uploadedFileData?.gamingBgColor ? uploadedFileData?.gamingBgColor : '#000000';
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.HERO_TILE, dataSet: {bgColor:this.bgColor} });
  }

  validateUrl(event) {
    const urlValue = event.target.value;
    this.patterMatch =  Utils.validateUrl(urlValue);
  }

  uploadHeroTileImage(event) {
    this.heroImageDoc = event.target.files;
    this.processFile(this.heroImageDoc, AssetLibraryConstants.HERO_TILE_PATH);
    this.heroTileFileName = this.imageFileName;
    this.heroTileSizeError = this.imageSizeError;
    this.heroTileAvailable = this.isImageAvailable;
    this.heroTileFormat = this.isImageFormat;
    this.heroTileTypeError = this.imageTypeError;
    this.heroImageURL = this.imageUrl;
    if (this.heroTileSizeError || this.heroTileTypeError) {
      this.heroImageURL = '';
    }
  }

  uploadGamingBanner(event) {
    this.gamingBannerDoc = event.target.files;
    this.processFile(this.gamingBannerDoc, AssetLibraryConstants.GAMING_BANNER_PATH);
    this.gamingBannerFileName = this.imageFileName;
    this.gamingBannerSizeError = this.imageSizeError;
    this.gamingBannerAvailable = this.isImageAvailable;
    this.gamingBannerFormat = this.isImageFormat;
    this.gamingBannerTypeError = this.imageTypeError;
    this.gamingBannerImageURL = this.imageUrl;
  }

  processFile(imageDoc, callFrom) {
    if (imageDoc) {
      const reader = new FileReader();
      reader.readAsDataURL(imageDoc[0]);
      this.imageFileName = imageDoc[0].name;
      this.imageFileType = imageDoc[0].type;
      this.imageFileSize = imageDoc[0].size;
      this.media.uploadedDate = new Date();
      const fileType = imageDoc[0].type.split('/')[1];
      if (this.imageFileType.indexOf(GlobalConstants.FILE_TYPE_IMAGE) > -1) {
        this.imageSizeError = this.imageFileSize > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
        if (fileType === GlobalConstants.CONTENT_TYPE_PNG ||
          fileType === GlobalConstants.CONTENT_TYPE_GIF ||
          fileType === GlobalConstants.CONTENT_TYPE_JPEG) {
          this.imageTypeError = false;
          if (this.isRemoveEnabled) {
            this.imageSizeError = false;
          }
        } else { this.imageTypeError = true; }
        this.isImageAvailable = !(this.imageSizeError || this.imageTypeError || (this.imageSizeError && this.imageTypeError));
        this.isImageFormat = true;
        this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(imageDoc[0]));
        if (this.heroImageDoc && callFrom === AssetLibraryConstants.HERO_TILE_PATH && !this.imageSizeError) {
          reader.onload = _event => {
            this.heroImageURL = reader.result;
            this.emitImageDataToPreview(this.heroImageDoc[0]);
          };
        }
      } else {
        this.imageTypeError = true;
        this.isImageFormat = false;
      }
    }
  }
  emitImageDataToPreview(imageDoc) {
    this.heroTilePreviewData.image.name = imageDoc ? imageDoc.name : '';
    this.heroTilePreviewData.image.url = imageDoc ? this.heroImageURL : '';
    this.heroTilePreviewData.image.format = imageDoc ? imageDoc.type : '';
    this.heroTilePreviewData.bgColor = this.bgColor ? this.bgColor : '';
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.HERO_TILE, dataSet: this.heroTilePreviewData });
  }

  uploadFallbackExe(event) {
    this.exeFileDoc = event.target.files;
    this.fileTypeError = true;
    this.isFileFormat = false;
    this.isFileAvailable = false;
    this.fileSizeError = true;
    if (this.exeFileDoc) {
      const reader = new FileReader();
      reader.readAsDataURL(this.exeFileDoc[0]);
      this.fileName = this.exeFileDoc[0].name;
      this.fileType = this.exeFileDoc[0].type;
      this.fileSize = this.exeFileDoc[0].size;
      this.media.uploadedDate = new Date();
      const fileType = this.exeFileDoc[0].type.split('/')[1];
      this.fileTypeError = (
                              this.fileType === GlobalConstants.ZIP_FILE_TYPE || 
                              this.fileType === GlobalConstants.ZIP_FILE_MAC
                            ) ? false : true;
      if (!this.fileTypeError) {
        // TODO - checked with Niraj we have no exe file validation , keeping this code for future reference
        // this.fileSizeError = (this.fileSize > GlobalConstants.UPLOAD_VIDEO_MAX_SIZE);
        this.fileSizeError = false;
      }
      if (!this.fileTypeError) {
        this.fileName = event.target.files[0].name;
        this.isFileAvailable = !(this.fileSizeError || this.fileTypeError || (this.fileSizeError && this.fileTypeError));
        this.isFileFormat = true;
        this.fileUrl = '';
        this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.exeFileDoc[0]));
      }
    }
  }

  getRetailerDetails() {
    this.heroTileService.getAllRetailerInfo()
    .pipe(takeUntil(this.ngUnsubscribe))
    .pipe(first())
    .subscribe(allRetailerInfo => {
      const retailerInfo = allRetailerInfo.retailer as RetailHq[];
      let tempHQArr = [];
      retailerInfo.forEach(element => {
        if (element.srtEnabled) {
          tempHQArr.push({id: element.retailerId, name: element.retailerName});
        }
      });
      this.listOfRetailerHq = tempHQArr;
    });
  }

  onAdd() {
    this.isSubmitted = true;
    this.isFormValid = this.heroTileForm?.controls?.publishedName?.value.trim() !== '';
    if (this.isFormValid) {
      if (this.selectedHeroTileId) { // Since attractor loop id exists, it is an update process
        this.updateHeroTile();
      } else {
        this.createHeroTile();
      }
    }
  }

  getSelectedRetailer(retailerData) {
    if(retailerData){
      this.selectedRetailerId = retailerData.id;
      this.selectedRetailerName = retailerData.name;
      this.selectedRetailer = retailerData.name;
      this.isRetailerAvailable = true;
    }else{
      this.isRetailerAvailable = false;
      this.selectedRetailer = retailerData;
    }
  }

  createHeroTile() {
    const heroTileConfiguration: HeroTileConfiguration = {
      heroImageFile: (this.heroImageDoc) ? this.heroImageDoc[0].name : this.heroTileFileName,
      gamingImageFile: (this.gamingBannerDoc) ? this.gamingBannerDoc[0].name : this.gamingBannerFileName,
      fallbackExeFile: (this.exeFileDoc) ? this.exeFileDoc[0].name : this.fileName,
      bgColor : this.bgColor,
      gamingBgColor : this.gamingBgColor
    };
    const heroTileData: HeroTilePreviewData = {
      publishedName: this.heroTileForm.controls.publishedName.value.trim(),
      internalName: this.heroTileForm.controls.internalName.value,
      srtUrl: this.heroTileForm.controls.srtUrl.value,
      callToAction: this.heroTileForm.controls.callToAction.value.trim(),
      retailerId: this.selectedRetailerId,
      retailerName: this.selectedRetailerName,
      configurations: JSON.stringify(heroTileConfiguration)
    };
    this.heroTileService.createHeroTile(JSON.stringify(heroTileData))
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async createHeroTileResponse => {
        const srtHeroTileId = createHeroTileResponse.srtHeroTile.id;
        await this.uploadImage(this.heroImageDoc[0], this.heroTileFileName.split('.')[1], srtHeroTileId, AssetLibraryConstants.HERO_TILE_PATH);
        await this.uploadImage(this.gamingBannerDoc[0], this.gamingBannerFileName.split('.')[1], srtHeroTileId,
          AssetLibraryConstants.GAMING_BANNER_PATH);
        await this.uploadImage(this.exeFileDoc[0], this.fileName.split('.')[1], srtHeroTileId, AssetLibraryConstants.FALLBACK_EXE);
        this.cmnSer.emitRefreshHeroTileData(true);
        this.refreshHeroTiledata.emit();
      });
  }

  uploadImage(file, fileType, srtHeroTileId, imageFor) {
    return new Promise((resolve, reject) => {
      this.heroTileService.putS3HeroTileDataByTileId(file, fileType, srtHeroTileId, imageFor)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe((data) => {
          resolve(data);
        },
          error => { // do something
          });
    });

  }

  updateHeroTile() {
    const heroTileConfiguration: HeroTileConfiguration = {
      heroImageFile: (this.heroImageDoc) ? this.heroImageDoc[0].name : this.heroTileFileName,
      gamingImageFile: (this.gamingBannerDoc) ? this.gamingBannerDoc[0].name : this.gamingBannerFileName,
      fallbackExeFile:(this.exeFileDoc) ? this.exeFileDoc[0].name : this.fileName,
      bgColor : this.bgColor,
      gamingBgColor : this.gamingBgColor
    };
    const heroTileData: HeroTilePreviewData = {
      publishedName: this.heroTileForm.controls.publishedName.value.trim(),
      internalName: this.heroTileForm.controls.internalName.value === null ? '' : this.heroTileForm.controls.internalName.value,
      srtUrl: this.heroTileForm.controls.srtUrl.value,
      callToAction: this.heroTileForm.controls.callToAction.value.trim(),
      retailerId: this.selectedRetailerId,
      retailerName: this.selectedRetailerName,
      configurations: JSON.stringify(heroTileConfiguration)
    };
    this.heroTileService.editHeroTileById(JSON.stringify(heroTileData), this.selectedHeroTileId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(async updateHeroTileResponse => {
        if(this.heroImageDoc){
          await this.uploadImage(this.heroImageDoc[0], this.heroTileFileName.split('.')[1], this.selectedHeroTileId, AssetLibraryConstants.HERO_TILE_PATH);
        }
        if(this.gamingBannerDoc) {
          await this.uploadImage(this.gamingBannerDoc[0], this.gamingBannerFileName.split('.')[1], this.selectedHeroTileId,
          AssetLibraryConstants.GAMING_BANNER_PATH);
        }
        if(this.exeFileDoc) {
          await this.uploadImage(this.exeFileDoc[0], this.fileName.split('.')[1], this.selectedHeroTileId, AssetLibraryConstants.FALLBACK_EXE);
        }

        this.cmnSer.emitRefreshHeroTileData(true);
        this.refreshHeroTiledata.emit();
      },
        error => { });
  }

  sendCTAText(ctavalue)
  {
  this.ctatextvalue.emit(ctavalue);
  }
  emitPageDataToPreview() {
    this.cmnSer.emitDataToLivePreview({ page: GlobalConstants.HERO_TILE, dataSet: {bgColor:this.bgColor} });
  }
  emitPageGamingDataToPreview(){}
}
